import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Mission } from '../mission.model';

@JsonObject('MissionsResultsResponse')
export class MissionsResultsResponse extends ApiResultsResponse<Mission> {

  @JsonProperty('results', [Mission])
  override results: Mission[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
